/**
 * 편집기 바꾸기 패널 열기 — 편집기 Ctrl+H 와 메뉴 편집 › 바꾸기가 이 함수 하나를 쓴다.
 *
 * 찾기는 편집기 툴바의 검색 창이 맡고(App.handleEditorFind), 바꾸기·정규식·단어 단위가 필요할 때만
 * CodeMirror 검색 패널을 연다. 패널은 찾기 칸에 포커스를 두므로 바꾸기 칸으로 옮긴다
 * (읽기 전용 편집기에는 바꾸기 칸이 없어 찾기 칸에 남는다).
 */
import { openSearchPanel } from '@codemirror/search';

export function openReplacePanel(view) {
  if (!view) return false;
  openSearchPanel(view);
  requestAnimationFrame(() => view.dom.querySelector('.cm-search [name="replace"]')?.focus());
  return true;
}
